import { render, staticRenderFns } from "./CustomersReact.vue?vue&type=template&id=4a8a74d8&"
import script from "./CustomersReact.vue?vue&type=script&lang=js&"
export * from "./CustomersReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports